import { subDays } from 'date-fns';
import omitBy from 'lodash/omitBy';
import { useEffect, useState } from 'react';
import { useLocalStorage } from 'usehooks-ts';

const useFirstTimeSeeingSummary = (buildSlug: string, summaryDate: string | null) => {
  const [builds, setBuilds] = useLocalStorage('aiFailedSummarySeen', {} as Record<string, number>);
  const [firstVisit] = useState(() => !builds[buildSlug]);
  useEffect(() => {
    if (!summaryDate) return;

    setBuilds((buildMap) => {
      const cutoffSeconds = Math.floor(+subDays(new Date(), 30) / 1000);
      const newMap = omitBy(buildMap, (value) => value < cutoffSeconds);
      const seconds = Math.floor(+new Date(summaryDate) / 1000);
      if (seconds > cutoffSeconds) {
        newMap[buildSlug] = seconds;
      }
      return newMap;
    });
  }, [setBuilds, buildSlug, summaryDate]);

  return firstVisit;
};

export const resetFirstTimeSeeingSummaryStorage = () => {
  localStorage.removeItem('aiFailedSummarySeen');
};

export default useFirstTimeSeeingSummary;
